import { Outlet } from 'react-router-dom';
import { useState, useEffect } from 'react';
import useRefreshToken from '../../hooks/useRefreshToken';
import useAuth from '../../hooks/useAuth';
import { Loader } from '../../global/index';

const PersistLogin = () => {
  const [isLoading, setIsLoading] = useState(true);
  const refresh = useRefreshToken();
  const { auth } = useAuth();

  useEffect(() => {
    let isMounted = true;

    const verifyRefreshToken = async () => {
      try {
        await refresh();
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
      } finally {
        // isMounted && setIsLoading(false);
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    // Avoids unwanted call to verifyRefreshToken
    // !auth?.accessToken && persist ? verifyRefreshToken() : setIsLoading(false);
    if (!auth?.accessToken) {
      verifyRefreshToken();
    } else {
      setIsLoading(false);
    }

    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // return <>{!persist ? <Outlet /> : isLoading ? <Loader /> : <Outlet />}</>;
  if (isLoading) {
    return <Loader />;
  }
  return <Outlet />;
};

export default PersistLogin;
